import dayjs from 'dayjs'
import { useEffect, useState } from 'react'

function useCountdown(dueDate?: string | Date) {
  // States
  const [remainingTime, setRemainingTime] = useState<number | null>(null)

  // Actions
  const formatCountdown = (ms: number | null) => {
    if (!ms || ms <= 0) return '00:00'

    const totalSeconds = Math.floor(ms / 1000)
    const totalMinutes = Math.floor(totalSeconds / 60)
    const totalHours = Math.floor(totalMinutes / 60)

    if (totalHours > 23) {
      const days = Math.floor(totalHours / 24)

      return `${days} ${days === 1 ? 'dia' : 'dias'}`
    }

    const pad = (value: number) => String(value).padStart(2, '0')
    const minutes = totalMinutes % 60
    const seconds = totalSeconds % 60

    return totalHours > 0
      ? `${pad(totalHours)}:${pad(minutes)}:${pad(seconds)}`
      : `${pad(minutes)}:${pad(seconds)}`
  }

  // Effects
  useEffect(() => {
    if (!dueDate) return undefined

    const updateRemaining = () => {
      const diff = dayjs(dueDate).diff(dayjs())
      setRemainingTime(diff > 0 ? diff : 0)
    }

    updateRemaining()
    const interval = setInterval(updateRemaining, 1000)

    return () => clearInterval(interval)
  }, [dueDate])

  return { formatCountdown, remainingTime }
}

export default useCountdown
